const faqs = [
  {
    q: '天狼影院是否需要注册才能观看？',
    a: '不需要。天狼影院所有视频资源均可免费在线观看，无需注册或登录，打开网站即可即点即播，享受流畅的高清观影体验。',
  },
  {
    q: '天狼影院的视频画质如何？是否支持高清？',
    a: '天狼影院提供1080P高清画质播放，部分热门资源支持4K超清。我们持续优化播放技术，确保您在任何网络环境下都能获得清晰流畅的观影体验。',
  },
  {
    q: '天狼影院支持哪些设备观看？',
    a: '天狼影院全面支持PC端、平板和手机端观看，无需下载任何软件或插件。通过浏览器即可访问，随时随地追剧看电影，真正做到多端同步。',
  },
  {
    q: '视频加载慢或卡顿怎么办？',
    a: '天狼影院采用先进的CDN加速技术和智能缓冲策略，确保即点即播不缓冲。如遇卡顿，建议切换播放线路或检查本地网络状况，我们提供了多线路备选方案。',
  },
  {
    q: '天狼影院的资源更新速度如何？',
    a: '天狼影院坚持每日更新，热门剧集和电影上线后最快2小时内同步更新。平台覆盖国产剧、韩剧、美剧、日剧、动漫、综艺等12大频道，每日更新超过200部影视资源。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于天狼影院的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-5 border border-background-200"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line text-primary-500"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}